import { h, Component } from 'preact'
import Utils from '../utils'
import { SVG } from '.'

class Bubble extends Component {
  componentWillMount() {
    const { body, media } = this.props
    this.content = { body }

    try {
      if (body) {
        this.processText(body)
      } else if (media) {
        this.processMedia(media)
      }
    } catch (e) {
      console.error(e)
    }
  }

  shouldComponentUpdate(prevProps) {
    if (prevProps.data) {
      if (
        prevProps.data['data-next-author'] !=
        this.props.data['data-next-author']
      ) {
        return true
      }
    }

    return false
  }

  getMediaUrl(media) {
    media || (media = this.props.media)

    return new Promise(async (resolve, reject) => {
      let url = await media.getContentTemporaryUrl()
      let expires = 0

      try {
        expires = parseInt(url.match(/Expires=(\d+)/)[1]) * 1000
      } catch (e) {}

      resolve({ url, expires })
    })
  }

  async processMedia(media) {
    let mediaUrl = await this.getMediaUrl(media)
    let content = { mediaUrl }

    if (media.state.contentType.startsWith('image/')) {
      content.img = { src: mediaUrl.url }
    } else {
      try {
        const size = Utils.bytesToSize(media.state.size)

        let ext = media.contentType
          .replace(/;.+/, '')
          .split('/')[1]
          .toLowerCase()

        if (ext == 'plain') {
          ext = 'txt'
        }

        let { filename } = media
        if (!filename) {
          filename = `${media.state.sid.substr(0, 10)}.${ext}`
        }

        content.document = { ext, size, filename }
      } catch (e) {
        content.link = { label: mediaUrl.url.split('?')[0] }
      }
    }

    this.content = content
    this.forceUpdate(this.props.onMediaLoaded)
  }

  async openMedia() {
    let { mediaUrl } = this.content
    let { url, expires } = mediaUrl

    const now = Date.now()

    if (!expires || expires > now) {
      let w = window.open()
      if (w) {
        w.opener = null
        w.location = url
      }
    } else {
      this.content.loading = true
      this.forceUpdate()

      mediaUrl = await this.getMediaUrl()
      this.content.mediaUrl = mediaUrl
      this.content.loading = false

      this.forceUpdate(() => {
        this.openMedia()
      })
    }
  }

  processText(text) {
    if (!text) return

    const sortPart = (a, b) => a.offset - b.offset
    const content = {}

    let parts = []
    let match

    const newlineRegex = /\n/gi
    while ((match = newlineRegex.exec(text))) {
      const offset = match.index
      parts.push({
        offset: offset,
        length: 1,
        component: <br />,
      })
    }

    // Auto link
    while ((match = Utils.FIND_LINK_REGEX.exec(text))) {
      let [_, url, label] = match,
        linkText = (label || url).trim()

      parts.push({
        offset: match.index,
        length: match[0].length,
        text: linkText,
        component: (
          <a href={url} target="_blank" rel="noopener nofollow">
            {linkText}
          </a>
        ),
      })
    }

    while ((match = Utils.FIND_URL_REGEX.exec(text))) {
      let url = match[2]

      // Don’t include trailing “)” when “)” counts doesn’t match “(”
      if (/\)$/.test(url)) {
        let openingMatches = url.match(/\(/g)
        let openingCount = openingMatches ? openingMatches.length : 0

        let closingMatches = url.match(/\)/g)
        let closingCount = closingMatches ? closingMatches.length : 0

        if (closingCount > openingCount) {
          url = url.slice(0, -1)
        }
      }

      let abort = false
      for (let part of parts) {
        if (
          match.index >= part.offset &&
          match.index < part.offset + part.length
        ) {
          abort = true
          break
        }
      }

      if (abort) break

      parts.push({
        offset: match.index + match[1].length,
        length: url.length,
        text: url,
        component: (
          <a href={url} target="_blank" rel="noopener nofollow">
            {url}
          </a>
        ),
      })
    }

    while ((match = Utils.FIND_EMAIL_REGEX.exec(text))) {
      let email = match[1]

      parts.push({
        offset: match.index,
        length: match[0].length,
        text: email,
        component: <a href={`mailto:${email}`}>{email}</a>,
      })
    }

    while ((match = Utils.FIND_TEL_REGEX.exec(text))) {
      let phone = match[1]

      parts.push({
        offset: match.index,
        length: match[0].length,
        text: phone,
        component: <a href={`tel:${phone}`}>{phone.replace(/\s/g, ' ')}</a>,
      })
    }

    parts = parts.sort(sortPart)
    const lastPart = parts[parts.length - 1] || { offset: 0, length: 0 }
    const index = lastPart.offset + lastPart.length

    let txt = text.substring(index)
    if (txt) {
      parts.push({
        offset: index,
        length: txt.length,
        text: txt,
        component: <span>{txt}</span>,
      })
    }

    parts.forEach((part, i) => {
      const previousPart = parts[i - 1] || { offset: 0, length: 0 }
      const index = previousPart.offset + previousPart.length
      if ((txt = text.substring(index, part.offset))) {
        parts.push({
          offset: index,
          length: txt.length,
          text: txt,
          component: <span>{txt}</span>,
        })
      }
    })

    // Huge emojis
    if (
      parts.length == 1 &&
      parts[0].text.length <= 12 &&
      !parts[0].text.match(/[a-zA-Z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/)
    ) {
      const text = parts[0].text.trim()

      let match = text.match(
        /\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff]/g,
      )

      if (match && match.length) {
        content.emojis = true
      }
    }

    content.parts = parts.sort(sortPart).map((p) => p.component)

    this.content = content
    this.forceUpdate()
  }

  renderContent() {
    const { body, parts, img, document, link } = this.content

    if (parts) {
      return parts
    } else if (img) {
      return (
        <img
          class="media"
          src={img.src}
          onLoad={this.props.onMediaLoaded}
          onClick={() => this.openMedia()}
        />
      )
    } else if (document) {
      return (
        <div class="document" onClick={() => this.openMedia()}>
          <div class="document-icon" data-ext={document.ext}>
            <SVG name="document" size={32} />
          </div>
          <div>
            <div class="document-filename">{document.filename}</div>
            <div class="document-size">{document.size}</div>
          </div>
        </div>
      )
    } else if (link) {
      return (
        <span class="link" onClick={() => this.openMedia()}>
          {link.label}
        </span>
      )
    } else {
      return body
    }
  }

  render() {
    if (this.props.onlyContent) {
      return this.renderContent()
    }

    let { data, avatar, username } = this.props
    let classes = ['bubble']

    if (this.content.loading) {
      classes.push('loading')
    }

    if (this.content.img) {
      classes.push('bubble-image')
    } else if (this.content.document) {
      classes.push('bubble-document')
    } else if (this.content.emojis) {
      classes.push('bubble-emojis')
    }

    return (
      <div class="row entry" {...data}>
        {username && (
          <div class="username">
            {avatar && <div class="avatar" />}
            <div class="username-content">
              <span>{username}</span>
            </div>
          </div>
        )}
        <div class="content">
          {avatar && (
            <div class="avatar">
              <img src={avatar} />
            </div>
          )}
          <div class={classes.join(' ')}>{this.renderContent()}</div>
        </div>
      </div>
    )
  }
}

export default Bubble
